import { Component, OnInit } from '@angular/core'
import { LaunchDialogService } from '@spartacus/storefront'
import {
  DialogResponse,
  VS_LAUNCH_CALLER,
} from '../../../../features/config/dialog.config'

@Component({
  standalone: false,
  selector: 'app-warning-dialog',
  templateUrl: './warning-dialog.component.html',
  styleUrls: ['./warning-dialog.component.scss'],
})
export class WarningDialogComponent {
  constructor(private launchDialogService: LaunchDialogService) {}

  // ngOnInit(): void {}
  closeModal(reason?: any): void {
    const dialogResponse: DialogResponse = {
      type: VS_LAUNCH_CALLER.WARNING_DIALOG,
      reason: reason,
    }
    this.launchDialogService.closeDialog(dialogResponse)
  }
}
